/**
 * Lấy tọa độ hiện tại của trình duyệt — dùng chung cho mọi nơi chỉ cần lat/lng (form chi nhánh, cài
 * đặt trụ sở chính...). Khác `components/layout/check-in-button.tsx`: chỗ đó còn reverse-geocode ra
 * địa chỉ hiển thị cho nhân viên lúc chấm công, các form cấu hình ở đây không cần địa chỉ.
 */
export interface Coordinates {
  latitude: number;
  longitude: number;
}

export const getCurrentCoordinates = (): Promise<Coordinates> => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Trình duyệt không hỗ trợ định vị."));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude });
      },
      (error) => {
        let message = "Không thể lấy vị trí hiện tại.";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            message = "Bạn đã từ chối cấp quyền truy cập vị trí. Vui lòng bật lại quyền định vị của trình duyệt.";
            break;
          case error.POSITION_UNAVAILABLE:
            message = "Không xác định được vị trí hiện tại. Kiểm tra lại kết nối mạng hoặc dịch vụ định vị của thiết bị.";
            break;
          case error.TIMEOUT:
            message = "Quá thời gian chờ lấy vị trí. Vui lòng thử lại.";
            break;
        }
        reject(new Error(message));
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  });
};
